module.exports = __webpack_public_path__ + "img/logo.943ef87f.png";